<template>

<div class="main main--hasHeader main--hasFooter">
      <div class="customContainer">
        <h2 class="members__headline">{{ word_chg('会員情報') }}</h2>
        <form method="post">
          <div class="members-member-form">
            <!-- <div class="members-member-form__wrapper">
              <p class="members-member-form__head">お名前</p>
              <div class="row gx-15 members-member-form__group">
                <div class="col-6">
                  <div class="members-member-form__head-sub">
                    <p>
                      <label for="first_name">姓</label>
                    </p>
                  </div>
                  <div class="members-member-form__data">
                    <input type="text" name="first_name" placeholder="">
                  </div>
                </div>
                <div class="col-6">
                  <div class="members-member-form__head-sub">
                    <p>
                      <label for="last_name">名</label>
                    </p>
                  </div>
                  <div class="members-member-form__data">
                    <input type="text" name="last_name" placeholder="">
                  </div>
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper">
              <p class="members-member-form__head">お名前（フリガナ）</p>
              <div class="row gx-15 members-member-form__group">
                <div class="col-6">
                  <div class="members-member-form__head-sub">
                    <p>
                      <label for="first_name_kana">セイ</label>
                    </p>
                  </div>
                  <div class="members-member-form__data">
                    <input type="text" name="first_name_kana" placeholder="">
                  </div>
                </div>
                <div class="col-6">
                  <div class="members-member-form__head-sub">
                    <p>
                      <label for="last_name_kana">メイ</label>
                    </p>
                  </div>
                  <div class="members-member-form__data">
                    <input type="text" name="last_name_kana" placeholder="">
                  </div>
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper">
              <p class="members-member-form__head">ご住所</p>
              <div class="row gx-15 members-member-form__group">
                <div class="col-6">
                  <div class="members-member-form__head-sub">
                    <p>
                      <label for="address_zip">郵便番号</label>
                    </p>
                  </div>
                  <div class="members-member-form__data">
                    <input type="text" name="address_zip" placeholder="">
                  </div>
                </div>
              </div>
              <div class="row gx-15 members-member-form__group">
                <div class="col-6">
                  <div class="members-member-form__head-sub">
                    <p>
                      <label for="address_select">都道府県</label>
                    </p>
                  </div>
                  <div class="members-member-form__data">
                    <select name="address_select">
                      <option value="">北海道</option>
                      <option value="東京都">東京都</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="members-member-form__group">
                <div class="members-member-form__head-sub">
                  <p>
                    <label for="address_detail01">市区町村</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <input type="text" name="address_detail01" placeholder="">
                </div>
              </div>
              <div class="members-member-form__group">
                <div class="members-member-form__head-sub">
                  <p>
                    <label for="address_detail02">番地</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <input type="text" name="address_detail02" placeholder="">
                </div>
              </div>
              <div class="members-member-form__group">
                <div class="members-member-form__head-sub">
                  <p>
                    <label for="address_detail03">建物名・部屋番号（任意）</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <input type="text" name="address_detail03" placeholder="">
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="tel_number">電話番号<span>※半角数字、ハイフン無しで入力</span></label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <input type="text" name="tel_number" placeholder="">
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="date_birth">生年月日<span>※半角数字、ハイフン無しで入力</span></label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <input type="text" name="date_birth" placeholder="">
                </div>
              </div>
            </div> -->
            <div class="members-member-form__wrapper">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="email_id">{{ word_chg('メールアドレス(お客様ID)') }}</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <label class="reserveRunSearch__checkLabel" style="font-size: 80%;">
                      <input class="reserveRunSearch__check" type="checkbox" v-model="confirm.id_chg_sw"/>{{ word_chg('メールアドレスを変更する') }}
                  </label>
                </div>
                <div class="members-member-form__data" v-if="confirm.id_chg_sw">
                  <input type="email" v-model="member.login_id" placeholder="">
                </div>
                <div class="members-member-form__data" v-else>
                  {{member.login_id}}
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper" v-if="confirm.id_chg_sw">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="email_id_confirm">{{ word_chg('メールアドレス（お客様ID）') }}[{{ word_chg('確認') }}]</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <input type="email" v-model="confirm.login_id" placeholder="">
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="password">{{ word_chg('パスワード') }}</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <label class="reserveRunSearch__checkLabel" style="font-size: 80%;">
                      <input class="reserveRunSearch__check" type="checkbox" v-model="confirm.pass_chg_sw"/>{{ word_chg('パスワードを変更する') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper" v-if="confirm.pass_chg_sw">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="password">{{ word_chg('パスワード') }}</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <input type="text" v-model="member.login_pass" placeholder="">
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper" v-if="confirm.pass_chg_sw">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="password_confirm">{{ word_chg('パスワード') }}[{{ word_chg('確認') }}]</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <input type="text" v-model="confirm.login_pass" placeholder="">
                </div>
              </div>
            </div>

            <div class="members-member-form__wrapper" v-if="false">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="PaymentMethod">{{ word_chg('ニックネーム') }}</label>
                  </p>
                </div>
                <div class="members-member-form__head">
                  <p style="font-weight: normal;">
                    {{ word_chg('英字でご記入下さい。') }}<br>
                    {{ word_chg('実際に走行する方は必ず記入して下さい。') }}
                  </p>
                </div>
                <div class="members-member-form__data">
                  <input type="text" v-model="member.driver_label" pattern="^[a-zA-Z]+$" name="first_name_kana" placeholder="">
                </div>
              </div>
            </div>

            <div class="members-member-form__wrapper">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="PaymentMethod">{{ word_chg('RH') }}</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <bs-select
                    :options="rh_list"
                    v-model="member.blood_type_rh"
                    :null-option="false"
                    :class-param="'form-select-sm'"
                    :name="'blood_type_rh'"
                    ></bs-select>
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="PaymentMethod">{{ word_chg('血液型') }}</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <bs-select
                    :options="abo_list"
                    v-model="member.blood_type_abo"
                    :null-option="false"
                    :class-param="'form-select-sm'"
                    :name="'blood_type_abo'"
                    ></bs-select>
                </div>
              </div>
            </div>

            <div class="members-member-form__wrapper">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="PaymentMethod">{{ word_chg('支払い方法') }}</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <bs-select
                    :options="payment_method_list"
                    v-model="member.payment_method"
                    :null-option="false"
                    :class-param="'form-select-sm'"
                    :name="'payment_method'"
                    ></bs-select>
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="PaymentMethod">{{ word_chg('言語設定') }}</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <bs-select
                    :options="app_lang_type_list"
                    v-model="member.app_lang_type"
                    :null-option="false"
                    :class-param="'form-select-sm'"
                    :name="'app_lang_type'"
                    ></bs-select>
                </div>
              </div>
            </div>
            <div class="members-member-form__wrapper d-none">
              <div class="members-member-form__group">
                <div class="members-member-form__head">
                  <p>
                    <label for="PaymentMethod">{{ word_chg('検索表示許可') }}</label>
                  </p>
                </div>
                <div class="members-member-form__data">
                  <bs-select
                    :options="search_flg_list"
                    v-model="member.friendship_search_flg"
                    :null-option="false"
                    :class-param="'form-select-sm'"
                    :name="'friendship_search_flg'"
                    ></bs-select>
                </div>
              </div>
            </div>
            <p class="members-member-form__confirm">
              <button type="button" @click="update">{{ word_chg('登録') }}</button>
            </p>
          </div>
        </form>
      </div>
    </div>
</template>
<script>

import config from '../../../const'
import { mapState } from 'vuex'
import BsSelect from '../../atoms/BsSelect.vue'
export default {
  name: 'UserDetailView',
  data: function () {
      return {
        confirm: {
          login_id: '',
          login_pass: '',
          id_chg_sw: false,
          pass_chg_sw: false
        },
        search_flg: {
          0: {
            label: '許可しない',
            key: 0
          },
          1: {
            label: '許可する',
            key: 1
          },
        },
      }
  },
  components: {
    BsSelect
  },
  methods: {
    update(){
      // alert('登録しました-demo-');
      const params = this.member;
      if(this.confirm.pass_chg_sw && this.member.login_pass == ''){
        alert(this.word_chg('password required'));
        return false;
      }
      else if(this.confirm.pass_chg_sw && this.confirm.login_pass != this.member.login_pass){
        alert(this.word_chg('passwords do not match'));
        return false;
      }
      else if(this.confirm.pass_chg_sw){
        params['login_pass'] = this.member.login_pass;
      }

      if(this.confirm.id_chg_sw && this.member.login_id == ''){
        alert(this.word_chg('mailaddress required'));
        return false;
      }
      else if(this.confirm.id_chg_sw && this.confirm.login_id != this.member.login_id){
        alert(this.word_chg('mailaddress do not match'));
        return false;
      }
      else if(this.confirm.id_chg_sw){
        params['login_id'] = this.member.login_id;
      }

      console.log('component methods', params);
      return this.$store.dispatch('updateBasic', {data: params, target: 'member' })
          .then((response) => {
            // this.back()
            console.log(response);
            if(response && response.data && response.data.alert && response.data.alert.title){
              if(response.data.alert.title == 'error'){
                // alert(response.data.alert.message);
                alert(this.word_chg(response.data.alert.message));
              }
              else{
                // alert(response.data.alert.message);
                alert(this.word_chg(response.data.alert.message));
              }
              
            }
            else{
              alert(this.word_chg('更新できませんでした。'));
            }
            // // this.back()
            // alert('更新しました');
            // this.alertMessage = this.btnLabel + 'しました';
            // this.alertClass = 'alert-success';
          })
          .catch(
            () => {
            err => Promise.reject(err);
            // alert('更新失敗');
            alert(this.word_chg('更新できませんでした。'));
              // this.alertMessage = this.btnLabel + 'できませんでした';
              // this.alertClass = 'alert-danger';
            }
          )
    },
    // login御
    loadUser(){
      const params = {};
      params['id'] = this.$store.state.auth.userId;
      console.log('params', params);
      return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
      .catch((err) => {
        console.log(err);
        Promise.reject(err)
      })
      .then(() => {})
      .finally(() => {});
    },

    loadAppLangType(){
            return this.$store.dispatch('fetchBasicLists', {data: {}, target: 'app_lang_type'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                        })
                        .finally(() => {
                            console.log(' pref', this.$store.state.apidata.app_lang_type);
                        })
    },
    loadPaymentMethod(){
            return this.$store.dispatch('fetchBasicLists', {data: {}, target: 'payment_method'})
                        .catch((err) => {
                          console.log('loadPaymentMethod', err);
                          Promise.reject(err)
                        })
                        .then(() => {
                          console.log('loadPaymentMethod then');})
                        .finally(() => {})
    },
    loadBloodTypeABO(){
            return this.$store.dispatch('fetchBasicLists', {data: {}, target: 'blood_type_abo'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                            console.log('loard complete tax');
                            console.log('this', this.$store.state.apidata.sex);
                            // this.$router.push({ path: '/login' })
                        })
                        .finally(() => {
                            console.log(' sex', this.$store.state.apidata.sex);
                        })

    },
    loadBloodTypeRH(){
            return this.$store.dispatch('fetchBasicLists', {data: {}, target: 'blood_type_rh'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                            console.log('loard complete tax');
                            console.log('this', this.$store.state.apidata.sex);
                            // this.$router.push({ path: '/login' })
                        })
                        .finally(() => {
                            console.log(' sex', this.$store.state.apidata.sex);
                        })

    },
  },
  computed: {
    ...mapState({
      app_lang_type_lists: state => state.apidata.app_lang_type,
      payment_method: state => state.apidata.payment_method,
      user: state => state.apidata.user,
      abo_type: state => state.apidata.blood_type_abo,
      rh_type: state => state.apidata.blood_type_rh,
    }),
    search_flg_list: function(){
      const tmp = [];
      if(this.search_flg){
        Object.values(this.search_flg).forEach(flg => {
          tmp.push({
            key: flg.key,
            label: this.word_chg(flg.label)
          })
        });
      }
      return tmp;
    },
    app_lang_type_list: function(){
      const tmp = [];
      if(this.app_lang_type_lists){
        Object.values(this.app_lang_type_lists).forEach(flg => {
          tmp.push({
            key: flg.key,
            label: this.word_chg(flg.label)
          })
        });
      }
      return tmp;
    },
    payment_method_list: function(){
      // return this.payment_method;
      const tmp = [];
      if(this.payment_method){
        Object.values(this.payment_method).forEach(flg => {
          tmp.push({
            key: flg.key,
            label: this.word_chg(flg.label)
          })
        });
      }
      return tmp;
    },
    abo_list: function(){
      // return this.abo_type;
      const tmp = [];
      if(this.abo_type){
        Object.values(this.abo_type).forEach(flg => {
          tmp.push({
            key: flg.key,
            label: this.word_chg(flg.label)
          })
        });
      }
      return tmp;
    },
    rh_list: function(){
      // return this.rh_type;
      const tmp = [];
      if(this.rh_type){
        Object.values(this.rh_type).forEach(flg => {
          tmp.push({
            key: flg.key,
            label: this.word_chg(flg.label)
          })
        });
      }
      return tmp;
    },
    getMyData: function(){
      const mydata = this.user.find((data) => {
        return data.id == this.$store.state.auth.userId;
      })
      return mydata;
    },
    axiosHeader: function(){
        return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
    },
    // customer: state => state.apidata.customer,
  },
  created () {
    this.loadPaymentMethod();
    this.loadAppLangType();
    this.loadUser();
    this.loadBloodTypeABO();
    this.loadBloodTypeRH();
    this.member = {...this.getMyData};
    this.member.login_pass = '';
  },
  mounted: function(){
  },
  props: {
  }

}
</script>
